<div class="content">

  <div class="text-left mt-5">

    <h3>Update User [Customer]</h3><br>

    <p>Update user details.</p><br>

    <p><a class="text-muted">REQUEST BODY SCHEMA:</a> application/json</p><hr>

    <p><b>A user information object</b></p><br>


    <div class="table-responsive">
      <table class="table table-primary table-bordered">
        <tbody>
            <tr>
            <td>
              <h6>name</h6>
            </td>
            <td colspan="4">
              <small>string</small>
              <p>
                [Mandatory] Name of the user
              </p>
            </td>
          </tr>

            <tr>
            <td>
              <h6>notification_email</h6>
            </td>
            <td colspan="4">
              <small>string</small>
              <p>
                [Optional for both crunch or customer managed] To notify to the customer, Expects a comma-separated
                value for more then one email ID
              </p>
            </td>
          </tr>

          <tr (click)="showVod = !showVod"  style="cursor: pointer;">
            <td>
              <h6  class="d-flex" >
                vod    &nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showVod" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showVod" class="fa fa fa-toggle-on" aria-hidden="true"></i>
                 </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

          <tr *ngIf="showVod">
             <td></td>
            <td class="w-25">
              <h6>primary_use</h6>
            </td>
            <td colspan="4">
              <small>string</small>
              <p>Primary use case of the user. Possible values - business, personal, both</p>
            </td>
          </tr>

           <tr *ngIf="showVod" (click)="show1 = !show1"  style="cursor: pointer;">
            <td></td>
            <td class="w-25">
              <h6  class="d-flex" >
                primary_storages&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!show1" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="show1" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4"> 
              <small>Array of objects</small>
              <p>Primary storages that user wish to connect with.
              </p>
            </td>
          </tr>

           <tr *ngIf="showVod && show1">
            <td></td>
            <td></td>
            <td>
              <h6>provider</h6>
            </td>
            <td>
              <small>string</small>
              <p>Provider name. Possible values - drive, dropbox, oci and s3</p>
            </td>
          </tr>


         <tr *ngIf="showVod && show1">
            <td></td>
            <td></td>
          <td>
            <h6>is_connected</h6>
          </td>
          <td>
            <small>boolean</small>
            <p>Flag indicating whether user is connected with the provider. Default value is false.</p>
          </td>
        </tr>


         <tr *ngIf="showVod" (click)="show2 = !show2"  style="cursor: pointer;">
          <td></td>
          <td>
            <h6 class="d-flex">
              upscaler_process_settings&nbsp;&nbsp;
              <div class="pt-0.5">
                <i style="float: right; font-size: 20px;" *ngIf="!show2" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="show2" class="fa fa fa-toggle-on" aria-hidden="true"></i>
            </div>
            </h6>
          </td>
          <td colspan="4">
            <small>object</small>
          </td>
        </tr>

         <tr *ngIf="showVod && show2">
         <td></td>
         <td></td>
          <td>
            <h6>type</h6>
          </td>
          <td>
            <small>string</small>
            <p>Enum: "1080p" "4K" "default"</p>
            <p> Upscaler processing type, default value is default.</p>
          </td>
        </tr>

         <tr *ngIf="showVod && show2">
            <td></td>
            <td></td>
          <td>
            <h6>ask_me_every_time</h6>
          </td>
          <td>
            <small>boolean</small>
            <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the type value everytime
              while submitting batch request</p>
          </td>
        </tr>

         <tr *ngIf="showVod" (click)="show3 = !show3"  style="cursor: pointer;">
          <td></td>
          <td>
            <h6 class="d-flex" >optimizer_process_settings&nbsp;&nbsp;
              <div class="pt-0.5">
                <i style="float: right; font-size: 20px;" *ngIf="!show3" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="show3" class="fa fa fa-toggle-on" aria-hidden="true"></i>
            </div>
            </h6>
          </td>
          <td colspan="4">
            <small>object</small>
          </td>
        </tr>

         <tr *ngIf="showVod && show3">   
          <td></td> 
          <td></td>        
          <td>
            <h6>type</h6>
          </td>
          <td>
            <small>string</small>
            <p>Enum: "size" "quality"</p>
            <p> Optimizer processing type, default value is size.</p>
          </td>
        </tr>

         <tr *ngIf="showVod && show3">
            <td></td>
            <td></td>
          <td>
            <h6>ask_me_every_time</h6>
          </td>
          <td>
            <small>boolean</small>
            <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the type value everytime
              while submitting batch request</p>
          </td>
        </tr>

         <tr *ngIf="showVod" (click)="show4 = !show4"  style="cursor: pointer;">
          <td></td>
          <td>
            <h6 class="d-flex" >
              upscaler_file_management_properties&nbsp;&nbsp;
              <div class="pt-0.5">
                <i style="float: right; font-size: 20px;" *ngIf="!show4" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="show4" class="fa fa fa-toggle-on" aria-hidden="true"></i>
            </div>
            </h6>
          </td>
          <td colspan="4">
            <small>object</small>
          </td>
        </tr>

         <tr *ngIf="showVod && show4">
            <td></td>
            <td></td>
          <td>
            <h6>file_copy_preference</h6>
          </td>
          <td>
            <small>string</small>
            <p>Enum: "replace_original_file" "create_copy" "manual_copy"</p>
            <p>Upscaler file copy preference sets how the output file must be stored, default value is manual_copy.
            </p>
          </td>
        </tr>

         <tr *ngIf="showVod && show4">
          <td></td>
          <td></td>
          <td>
            <h6>ask_me_every_time</h6>
          </td>
          <td>
            <small>boolean</small>

            <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the file_copy_preference
              value everytime while submitting batch request</p>
          </td>
        </tr>

         <tr *ngIf="showVod" (click)="show5 = !show5"  style="cursor: pointer;">
            <td></td>
          <td>
            <h6 class="d-flex">optimizer_file_management_properties&nbsp;&nbsp;
              <div class="pt-0.5">
                <i style="float: right; font-size: 20px;" *ngIf="!show5" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="show5" class="fa fa fa-toggle-on" aria-hidden="true"></i>
            </div>
            </h6>
          </td>
          <td colspan="4">
            <small>object</small>
          </td>
        </tr>

           <tr *ngIf="showVod && show5">
             <td></td>
             <td></td>
            <td>
              <h6>file_copy_preference</h6>
            </td>
            <td>
              <small>string</small>

              <p>Enum: "replace_original_file" "create_copy" "manual_copy"</p>
              <p>
                Upscaler file copy preference sets how the output file must be stored, default value is manual_copy.
              </p>
            </td>
          </tr>

           <tr *ngIf="showVod && show5">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td>
              <small>boolean</small>
              <p>
                [Mandatory] Ask me everytime flag can be set to true if the user must be asked the file_copy_preference
                value everytime while submitting batch request
              </p>
            </td>
          </tr>


            <tr (click)="showImg = !showImg"  style="cursor: pointer;">
            <td>
              <h6 class="d-flex">
                image &nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showImg" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showImg" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

           <tr *ngIf="showImg" (click)="showimg1 = !showimg1"  style="cursor: pointer;">
            <td></td>
            <td class="w-25">
              <h6 class="d-flex">
                upscaler_process_settings
                <div class="pt-0.5">&nbsp;&nbsp;
                  <i style="float: right; font-size: 20px;" *ngIf="!showimg1" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showimg1" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

           <tr *ngIf="showImg && showimg1">
            <td></td>
            <td></td>
            <td>
              <h6>type</h6>
            </td>
            <td>
              <small>string</small>
              <p>Enum: "4x" "2x"</p>
              <p>Upscaler processing type, default value is 4x.</p>
            </td>
          </tr>

           <tr *ngIf="showImg && showimg1">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the type value everytime
                while submitting batch request</p>
            </td>
          </tr>

           <tr *ngIf="showImg" (click)="showimg2 = !showimg2"  style="cursor: pointer;">
            <td></td>
            <td>
              <h6  class="d-flex" >optimizer_process_settings &nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showimg2" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showimg2" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>


           <tr *ngIf="showImg && showimg2">
            <td></td>
            <td></td>
            <td>
              <h6>type</h6>
            </td>
            <td colspan="4">
              <small>string</small>
              <p>Enum: "size"</p>
              <p>Optimizer processing type, default value is size.</p>
            </td>
          </tr>

           <tr *ngIf="showImg && showimg2">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Enum: "size"</p>
              <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the type value everytime
                while submitting batch request</p>
            </td>
          </tr>

           <tr *ngIf="showImg" (click)="showimg3 = !showimg3"  style="cursor: pointer;">
            <td></td>
            <td>
              <h6 class="d-flex">
                upscaler_file_management_properties&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showimg3" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showimg3" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg3">
            <td></td>
            <td></td>
            <td>
              <h6>file_copy_preference</h6>
            </td>
            <td>
              <small>string</small>
              <p>Enum: "replace_original_file" "create_copy" "manual_copy"</p>
              <p>Upscaler file copy preference sets how the output file must be stored, default value is manual_copy.
              </p>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg3">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td>
              <small>boolean</small>
              <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the file_copy_preference
                value everytime while submitting batch request</p>
            </td>
          </tr>

            <tr *ngIf="showImg" (click)="showimg4 = !showimg4"  style="cursor: pointer;">
            <td></td>
            <td>
              <h6 class="d-flex" >
                optimizer_file_management_properties&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showimg4" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showimg4" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg4">
            <td></td>
            <td></td>
            <td>
              <h6>file_copy_preference</h6>
            </td>
            <td colspan="4">
              <small>string</small>
              <p>Enum: "replace_original_file" "create_copy" "manual_copy"</p>
              <p>Upscaler file copy preference sets how the output file must be stored, default value is manual_copy.
              </p>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg4">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the file_copy_preference
                value everytime while submitting batch request</p>
            </td>
          </tr>

            <tr *ngIf="showImg" (click)="showimg5 = !showimg5"  style="cursor: pointer;">
            <td></td>
            <td>
              <h6 class="d-flex">
                enhancer_process_settings&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showimg5" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showimg5" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg5">
            <td></td>
            <td></td>
            <td>
              <h6>type</h6>
            </td>
            <td>
              <small>string</small>
              <p>Enum: "1x" "2x" "3x" "4x"</p>
              <p>Enhancer processing type, default value is 4x.</p>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg5">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td>
              <small>boolean</small>
              <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the type value everytime
                while submitting batch request</p>
            </td>
          </tr>

           <tr *ngIf="showImg" (click)="showimg6 = !showimg6"  style="cursor: pointer;">
            <td></td>
            <td>
              <h6 class="d-flex" >
                enhancer_file_management_properties&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showimg6" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showimg6" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg6">
            <td></td>
            <td></td>
            <td>
              <h6>file_copy_preference</h6>
            </td>
            <td>
              <small>string</small>
              <p>Enum: "replace_original_file" "create_copy" "manual_copy"</p>
              <p>Enhancer file copy preference sets how the output file must be stored, default value is manual_copy.
              </p>
            </td>
          </tr>

            <tr *ngIf="showImg && showimg6">
            <td></td>
            <td></td>
            <td>
              <h6>ask_me_every_time</h6>
            </td>
            <td>
              <small>boolean</small>
              <p>[Mandatory] Ask me everytime flag can be set to true if the user must be asked the file_copy_preference
                value everytime while submitting batch request</p>
            </td>
          </tr>

            <tr (click)="showemail = !showemail"  style="cursor: pointer;">
            <td>
              <h6   class="d-flex"   >
                email_notification_settings&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showemail" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showemail" class="fa fa fa-toggle-on" aria-hidden="true"></i>
                </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
              <p>Email notification settings for customer</p>
            </td>
          </tr>


            <tr *ngIf="showemail">
            <td></td>
            <td class="w-25">
              <h6>notify_when_file_processed</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Notify users when job has been processed/failed</p>
            </td>
          </tr>

          <tr *ngIf="showemail">
            <td></td>
            <td>
              <h6>notify_when_limit_reached</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Notify users when optimizer/upscaler approaching the limit</p>
            </td>
          </tr>

          <!-- <tr *ngIf="showemail">
            <td></td>
            <td>
              <h6>account_related_notification</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Account related notification</p>
            </td>
          </tr> -->

           <tr (click)="showStorage = !showStorage"  style="cursor: pointer;">
            <td>
              <h6 class="d-flex" >
                storage_connection_details&nbsp;&nbsp;
                <div class="pt-0.5">
                  <i style="float: right; font-size: 20px;" *ngIf="!showStorage" class="fa fa fa-toggle-off" aria-hidden="true"></i>
                  <i style="float: right; font-size: 20px; color: cornflowerblue;" *ngIf="showStorage" class="fa fa fa-toggle-on" aria-hidden="true"></i>
              </div>
              </h6>
            </td>
            <td colspan="4">
              <small>object</small>
              <p>Storage connection details, which indicates if the user is connected to any of the storage providers</p>
            </td>
          </tr>

          <tr *ngIf="showStorage">
            <td></td>
            <td class="w-25">
              <h6>s3</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Flag which indicates if S3 is connected</p>
            </td>
          </tr>

          <tr *ngIf="showStorage">
            <td></td>
            <td>
              <h6>oci</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Flag which indicates if OCI is connected</p>
            </td>
          </tr>

          <tr *ngIf="showStorage">
            <td></td>
            <td>
              <h6>googledrive</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Flag which indicates if Google Drive is connected</p>
            </td>
          </tr>

            <tr *ngIf="showStorage">
            <td></td>
            <td>
              <h6>dropbox</h6>
            </td>
            <td colspan="4">
              <small>boolean</small>
              <p>Flag which indicates if Dropbox is connected</p>
            </td>
          </tr>


        </tbody>
      </table>
    </div><br><br>






    <div class="card text-bg-dark mb-3">
      <div class="card-body">
        <pre><button type="button" class="btn btn-success">PUT</button>  https://api.optimusdrive.ai/v1/customer/update</pre>
      </div>
    </div> <br><br>


    <h5>Request samples</h5><br>

    <!-- <p><b>Example: 1</b></p><br> -->
    <div class="card text-bg-dark mb-3">
      <div class="card-body">

        <div class="card-title">
          <button style="float: right;" *ngIf="copyButton1" class="btn btn-outline-primary btn-sm"
            (click)="copyJsonToClipboard1()">
            <i class="fa fa-clipboard" aria-hidden="true"></i>
          </button>

          <button style="float: right;" *ngIf="copiedButton1" class="btn btn-success btn-sm">
            Copied <i class="fa fa-check" aria-hidden="true"></i>
          </button>

        </div><br><br>

        <pre><code [innerHTML]="requestData" id="json-code hljs json"></code></pre>
      </div>
    </div><br><br>

    <div>

      <h5>Response samples</h5><br>

      <div class="card text-bg-light mb-3">
        <div class="card-body">

          <div class="panel panel-primary">
            <div class="tab-menu-heading">
              <ul class="nav nav-pills" role="tablist">
                <!-- Tab menu items -->
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="tab1" data-bs-toggle="tab" data-bs-target="#content1"
                    type="button" role="tab" aria-controls="content1" aria-selected="true">200</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#exampleContent2"
                    type="button" role="tab" aria-controls="content2" aria-selected="false">400</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="tab3" data-bs-toggle="tab" data-bs-target="#content3" type="button"
                    role="tab" aria-controls="content3" aria-selected="false">401</button>
                </li>
              </ul>
            </div>

            <div class="panel-body tabs-menu-body mt-4">
              <div class="tab-content">
                <!-- Tab content -->
                <div class="tab-pane fade show active" id="content1" role="tabpanel" aria-labelledby="tab1">
                  <div class="card-body">
                    <pre><code [innerHTML]="sucessData" ></code></pre>
                  </div>
                </div>

                <div class="tab-pane fade" id="exampleContent2" role="tabpanel" aria-labelledby="tab2">
                  <div class="card-body" id="content2">
                    <pre><code [innerHTML]="Error4x" ></code></pre>
                  </div><br>

                  <div class="card-body" id="content2">
                    <pre><code [innerHTML]="Error42x" ></code></pre>
                  </div><br>

                </div>

                <div class="tab-pane fade" id="content3" role="tabpanel" aria-labelledby="tab3">
                  <div class="card-body">
                    <pre><code [innerHTML]="Error401x" ></code></pre>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div> <br><br>

    </div><br><br>

  </div>

</div>